<template>
    <div>
        <v-btn
            @click="action == 'create' ? save() : edit()"
            class="buttons buttons--add"
            :disabled="disabled"
        >
            {{ $t('storage:send') }}
        </v-btn>
    </div>
</template>
<script>
import { mapActions, mapGetters } from 'vuex'
export default {
    props: {
        action: {
            type: String,
        },
    },
    data() {
        return {
            disabled: false,
        }
    },
    computed: {
        ...mapGetters(['getProfileDetails']),
    },
    methods: {
        ...mapActions(['copyFromTemplates']),
        async save() {
            this.disabled = true
            let success = await this.copyFromTemplates({
                additional: {
                    routeName: this.$route.name,
                    routeId: this.$route.params.id,
                    createdBy: this.getProfileDetails._id,
                },
            })
            if (success) this.$emit('closeModal')
            this.disabled = false
        },
        async edit() {},
    },
}
</script>
